<template>
  <div class="mb48 orderSearch tms-style">
    <el-card class="mtf1">
      <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="100px" label-position="left" class="custom-el-form">
        <el-form-item :label="$t('DomesticMarineTransportation.CustomerCode')" style="width: 24%">
          <el-input v-model="searchForm.Customer_No" size="small" class="custom-input" />
        </el-form-item>
        <el-form-item :label="$t('DomesticMarineTransportation.JobNo')" style="width: 24%">
          <el-input v-model="searchForm.Booking_No" size="small" class="custom-input" />
        </el-form-item>
        <el-form-item :label="$t('DomesticMarineTransportation.WaterwayShippingNumber')" style="width: 24%">
          <el-input v-model="searchForm.MBL_NO" size="small" class="custom-input" />
        </el-form-item>
        <el-form-item :label="$t('DomesticMarineTransportation.OrderRange')" style="width: 28%">
          <el-date-picker v-model="searchForm.CreateInterval" type="daterange" range-separator="~" format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small" class="custom-input" :picker-options="pickerOptions" />
        </el-form-item>
        <el-form-item :label="$t('DomesticMarineTransportation.ContainerNumber')" style="width: 24%">
          <el-input v-model="searchForm.Container_No" size="small" class="custom-input" />
        </el-form-item>
        <el-form-item :label="$t('SeaFreight.PortofLoading')" style="width: 24%">
          <RemoteSelect :value.sync="searchForm.POL_Name" :width="400" @remoteQuery="remoteQueryPOL" @remoteSelect="remoteSelect">
            <template #columns>
              <el-table-column width="100" property="seaportCode" :label="$t('SeaFreight.Code')" />
              <el-table-column :property="$t('DomesticMarineTransportation.seaport')" :label="$t('SeaFreight.Name')" />
            </template>
          </RemoteSelect>
        </el-form-item>
        <el-form-item :label="$t('SeaFreight.PortofDestination')" style="width: 24%">
          <RemoteSelect :value.sync="searchForm.POD_Name" :width="400" @remoteQuery="remoteQueryPOD" @remoteSelect="remoteSelect">
            <template #columns>
              <el-table-column width="100" property="seaportCode" :label="$t('SeaFreight.Code')" />
              <el-table-column :property="$t('DomesticMarineTransportation.seaport')" :label="$t('SeaFreight.Name')" />
            </template>
          </RemoteSelect>
        </el-form-item>
        <div class="custom-flex-center" style="margin-top: 20px">
          <el-button type="primary" size="small" class="buttonSize" icon="el-icon-search" :loading="fullscreenLoading" @click="query">{{ $t('DomesticMarineTransportation.Search') }}</el-button>
          <el-button size="small" class="search buttonSize" icon="el-icon-refresh-right" :loading="fullscreenLoading" @click="empty">{{ $t('DomesticMarineTransportation.Reset') }}</el-button>
          <el-button size="small" class="search buttonSize" icon="el-icon-download" :loading="fullscreenLoading" @click="exportData">{{ $t('DomesticMarineTransportation.Export') }}</el-button>
        </div>
      </el-form>
    </el-card>
    <el-card class="mt10">
      <div class="custom-flex-space-between mb20">
        <div style="font-size: 16px">{{ $t('DomesticMarineTransportation.DetailView') }}</div>
        <el-tooltip class="showType" effect="dark" :open-delay="500" :content="showType ? $t('DomesticMarineTransportation.Switch') : $t('DomesticMarineTransportation.Switch')" placement="bottom">
          <img v-if="showType" src="@/assets/fms/order_list_card.png" @click="showTypeChange">
          <img v-else src="@/assets/fms/order_list_table.png" @click="showTypeChange">
        </el-tooltip>
      </div>
      <el-collapse v-if="showType" v-model="activeNames" v-loading="loading" class="custom-el-collapse el-collapse">
        <el-collapse-item v-for="i in dataList" :key="i.Booking_No" :name="i.Booking_No">
          <div slot="title" class="w100">
            <div class="order-title custom-flex-space-between" @click="toggleCollapse(i)">
              <img src="@/assets/fms/订单.png" class="order-img">
              <div style="flex:1">
                <div class="custom-flex-space-between">
                  <div class="inline-block ml18" style="width:30%">
                    <span class="order-label">{{ $t('DomesticMarineTransportation.CustomerCode') }} : </span>
                    <span class="order-text">{{ i.Customer_No }}</span>
                  </div>
                  <div class="inline-block " style="width:30%">
                    <span class="order-label">{{ $t('DomesticMarineTransportation.JobNo') }} : </span>
                    <span class="order-text-booking">{{ i.Booking_No }}</span>
                  </div>
                  <div class="inline-block " style="width:40%">
                    <span class="order-label">{{ $t('DomesticMarineTransportation.OrderRange') }} : </span>
                    <span class="order-text">{{ convertYMD(i.CreateDT) }}</span>
                  </div>
                </div>
                <div class="custom-flex-space-between">
                  <div class="inline-block ml18" style="width:30%">
                    <span class="order-label">{{ $t('DomesticMarineTransportation.LoadingPort') }} : </span>
                    <span class="order-text">{{ getUpper(i[$t('DomesticMarineTransportation.POLKey')]) }}</span>
                  </div>
                  <div class="inline-block " style="width:30%">
                    <span class="order-label">{{ $t('DomesticMarineTransportation.DestinationPort') }} : </span>
                    <span class="order-text">{{ getUpper(i[$t('DomesticMarineTransportation.PODKey')]) }}</span>
                  </div>
                  <div class="inline-block " style="width:40%">
                    <span class="order-text">{{ i.CoTypeCount }}</span>
                  </div>
                </div>
              </div>
              <span class="collapsed">{{ i.collapsed ? $t('DomesticMarineTransportation.Collapse') : $t('DomesticMarineTransportation.DetailView') }}</span>
            </div>
          </div>
          <div class="custom-flex-space-between">
            <div class="w100 order-title-wrap">
              <el-row class="w100" style="display: flex;margin-left: 17px">
                <div style="width:25%">
                  <el-row class="details-text">
                    <el-col class="details-label">{{ $t('DomesticMarineTransportation.TotalNumberofPieces') }} : </el-col>
                    <el-col class="details-value">{{ i.Pkgs_Num +' ('+(i.Pkgs_Unit || '')+')' }}</el-col>
                  </el-row>
                </div>
                <div style="width:25%">
                  <el-row class="details-text">
                    <el-col class="details-label">{{ $t('DomesticMarineTransportation.GrossWeightKGS') }} : </el-col>
                    <el-col class="details-value">{{ ext.roundFixed(i.GW,2) }}</el-col>
                  </el-row>
                </div>
                <div style="width:25%">
                  <el-row class="details-text">
                    <el-col class="details-label">{{ $t('DomesticMarineTransportation.VolumeCBM') }} : </el-col>
                    <el-col class="details-value">{{ ext.roundFixed(i.CBM,2) }}</el-col>
                  </el-row>
                </div>
                <div style="width:25%">
                  <el-row class="details-text">
                    <el-col class="details-label">{{ $t('DomesticMarineTransportation.ContainerNumber') }} : </el-col>
                    <el-col class="details-value">
                      <el-tooltip :content="i.Container_No" placement="top-start" effect="dark">
                        <div class="text-content">{{ i.Container_No }}</div>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                </div>
                <div style="">
                  <el-row>
                    <el-button type="primary" class="custom-el-button" size="small" style="display: block; width: 102px" @click="downloadAttachment(i)">
                      <span><img src="@/assets/fms/下载.png">{{ $t('DomesticMarineTransportation.DownloadAttachment') }}</span>
                    </el-button>
                  </el-row>
                  <!-- <el-row style="top:10px" v-if="i.InteriorCount>0">
                    <el-button type="primary" class="custom-el-button" size="small" style="display: block; width: 102px" @click="downloadInterior(i)">
                      <span><img src="@/assets/fms/下载.png">{{ $t('DomesticMarineTransportation.InteriorAttachment') }}</span>
                    </el-button>
                  </el-row> -->
                </div>
              </el-row>
              <el-row class="details-text" style="margin-left: 17px">
                <el-col class="details-label">{{ $t('DomesticMarineTransportation.Goods2') }} : </el-col>
                <el-col class="details-value">
                  <el-tooltip :content="i[$t('DomesticMarineTransportation.GoodsKey')]" placement="top-start" effect="dark">
                    <div class="text-content">{{ i[$t('DomesticMarineTransportation.GoodsKey')] }}</div>
                  </el-tooltip>
                </el-col>
              </el-row>
              <el-row class="w100">
                <OrderStep :statu-list="getMilestoneData(i)" />
              </el-row>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div v-else style="padding: 0px 20px 20px 20px">
        <el-table ref="orderTable" v-loading="loading" :data="dataList">
          <el-table-column type="index" width="50" :index="getIndex" :label="$t('DomesticMarineTransportation.SerialNumber')" />
          <el-table-column prop="Customer_No" width="150" :label="$t('DomesticMarineTransportation.CustomerCode')" />
          <el-table-column prop="Booking_No" width="150" :label="$t('DomesticMarineTransportation.JobNo')" />
          <el-table-column prop="MBL_NO" width="180" :label="$t('DomesticMarineTransportation.WaterwayShippingNumber')" />
          <el-table-column prop="AUDIT_TYPE" width="120" :label="$t('DomesticMarineTransportation.OrderStatus')" :formatter="(row)=>{
              return orderNode(row)
            }" />
          <!-- <el-table-column prop="Job_Type" width="150" :label="$t('DomesticMarineTransportation.BusinessType')" :formatter="(row)=>{
              return $t('DomesticMarineTransportation.MM')
            }" /> -->
          <el-table-column :label="$t('DomesticMarineTransportation.OrderRange')" prop="CreateDT" width="120" :formatter="(row)=>{
              return convertYMD(row.CreateDT)
            }" />
          <el-table-column :prop="$t('DomesticMarineTransportation.POLKey')" width="200" :label="$t('DomesticMarineTransportation.LoadingPort')" :formatter="formatUpper" />
          <el-table-column :prop="$t('DomesticMarineTransportation.PODKey')" width="200" :label="$t('DomesticMarineTransportation.DestinationPort')" :formatter="formatUpper" />
          <el-table-column prop="CoTypeCount" width="200" :label="$t('DomesticMarineTransportation.Containers')">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.CoTypeCount" placement="top-start" effect="dark">
                <div class="text-content">{{ scope.row.CoTypeCount }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="Container_No" width="200" :label="$t('DomesticMarineTransportation.ContainerNumber')">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.Container_No" placement="top-start" effect="dark">
                <div class="text-content">{{ scope.row.Container_No }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column :prop="$t('DomesticMarineTransportation.GoodsKey')" width="500" :label="$t('DomesticMarineTransportation.Goods')">
            <!-- <template slot-scope="scope">
              <el-tooltip :content="scope.row.Goods_CN_COUNT" placement="top-start" effect="dark">
                <div class="text-content">{{ scope.row.Goods_CN_COUNT }}</div>
              </el-tooltip>
            </template> -->
          </el-table-column>
          <el-table-column :label="$t('DomesticMarineTransportation.Operation')" fixed="right" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="downloadAttachment(scope.row)">{{ $t('DomesticMarineTransportation.DownloadAttachment') }}</el-button>
              <!-- <el-button type="text" size="small" @click="downloadInterior(scope.row)" v-if="scope.row.InteriorCount>0">{{ $t('DomesticMarineTransportation.CFSAttachment') }}</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <div class="footPage">
      <el-pagination class="custom-el-pagination floatR" background layout="sizes, prev, pager, next" :current-page.sync="curPageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="listTotalCount" @size-change="pageSizeChangeHandle" @current-change="curPageChangeHandle" />
    </div>
    <OceanfileDialog v-if="oceanfileDialogShow" :visible.sync="oceanfileDialogShow" :title="curTitle" :cur-row="curRow" job-type="MM" />
    <!-- <OceanInteriorDialog
      v-if="oceanInteriorDialogShow"
      :visible.sync="oceanInteriorDialogShow"
      :title="interiorTitle"
      :cur-row="interiorRow"
      job-type="MM"
    /> -->
  </div>
</template>
<script>
import { getDomesticTradePageList } from '@/api/ocean/order/mm/index'
import OrderStep from '@/components/fms/orderStep/index.vue'
import {
  convertYMD,
  conversionTime,
  parseTime,
  dateAddDays,
  dateAdds
} from '@/utils/index'
import { ISStr, EnumValueLocal, DataTimeMap } from '@/utils/isClass'
import { GetSeaProts } from '@/api/ocean/order/oe/index'
import OceanfileDialog from '@/components/fms/Dialog/oceanfileDialog.vue'
import { exportToExcel } from '@/vendor/Export2Excel.js'
import { tableRowClassName } from '@/utils/fms/tableClass'
import OceanInteriorDialog from '@/components/fms/Dialog/oceanInteriorDialog.vue'
import RemoteSelect from '@/components/fms/remoteSelect.vue'
const searchForm = {
  Customer_Code: '', //
  Booking_No: '', // OM00SH240100902
  Customer_No: '',
  MBL_HBL_NO: '',
  POL_Name: '',
  POD_Name: '',
  CreateInterval: [
    parseTime(dateAdds(new Date(), -30, 'd'), '{y}-{m}-{d}'),
    parseTime(new Date(), '{y}-{m}-{d}')
  ], // ["2023-06-01","2023-06-30"]
  Container_No: ''
}
export default {
  components: { OrderStep, OceanfileDialog, OceanInteriorDialog, RemoteSelect },
  props: {
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      EnumValueLocal,
      ISStr,
      convertYMD,
      conversionTime,
      tableRowClassName,
      loading: false,
      showType: true,
      fullscreenLoading: false,
      activeNames: [],
      dataList: [],
      searchForm: JSON.parse(JSON.stringify(searchForm)),
      searchSendCarForm: JSON.parse(JSON.stringify(searchForm)), // 搜索条件
      listTotalCount: 0,
      curPageIndex: 1,
      pageIndex: 1,
      pageSize: 10,
      oceanfileDialogShow: false,
      curTitle: this.$t('DomesticMarineTransportation.Download'),
      curRow: {},
      oceanInteriorDialogShow: false,
      interiorTitle: 'CFS ' + this.$t('DomesticMarineTransportation.Download'),
      interiorRow: {},
      disabledDateRange: [],
      pickerOptions: {
        disabledDate: (time) => {
          if (this.disabledDateRange && this.disabledDateRange.length > 0) {
            return (
              time.getTime() < this.disabledDateRange[0].getTime() ||
              time.getTime() > this.disabledDateRange[1].getTime()
            )
          } else {
            return false
          }
        },
        onPick: (picks) => {
          if (picks.maxDate) {
            this.disabledDateRange = []
          } else {
            this.disabledDateRange = [
              dateAdds(picks.minDate, -30, 'd'),
              dateAdds(picks.minDate, 30, 'd')
            ]
          }
        }
      }
    }
  },
  computed: {},
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    getIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    showTypeChange() {
      this.showType = !this.showType
    },
    /**  查询 */
    query() {
      this.fullscreenLoading = true
      var _this = this
      this.pageIndex = 1
      this.searchSendCarForm = JSON.parse(JSON.stringify(_this.searchForm))
      this.getList()
    },
    /**  清空 */
    empty() {
      this.searchForm = JSON.parse(JSON.stringify(searchForm))
      this.searchSendCarForm = JSON.parse(JSON.stringify(searchForm))
    },
    /**  列表查询 */
    getList() {
      this.loading = true
      const pagination = {}
      pagination.pageIndex = this.pageIndex
      pagination.pagesize = this.pageSize
      pagination.sort = 'CreateDT'
      const data = {}
      this.searchSendCarForm.Customer_Code = this.customerCode
      data.pagination = JSON.stringify(pagination)
      data.queryJson = JSON.stringify(this.searchSendCarForm)
      getDomesticTradePageList(data)
        .then((res) => {
          var data = JSON.parse(res.data)
          this.listTotalCount = data?.total
          const result = data?.rows ?? []
          this.dataList = result
          this.activeNames = []
          this.curPageIndex = this.pageIndex
          this.loading = false
          this.fullscreenLoading = false
        })
        .catch((err) => {
          this.loading = false
          this.fullscreenLoading = false
          console.log(err)
        })
    },
    pageSizeChangeHandle(size) {
      this.pageSize = size
      this.pageIndex = 1
      this.getList()
    },
    curPageChangeHandle(pageIndex) {
      this.pageIndex = pageIndex
      this.getList()
    },
    /**  节点 */
    getMilestoneData(item) {
      const data = []
      try {
        // 精准匹配
        const serviceRequests = item.Service_Request?.split(',')
        const isPOL = serviceRequests?.includes('起运港派车')
        const isDC = serviceRequests?.includes('订舱')
        const isPOD = serviceRequests?.includes('目的港派车')
        data.push({
          Name: this.$t('DomesticMarineTransportation.OrderReceived'),
          EventDT: this.milestoneTime(item.ReceivingOrdersTime),
          OpenImg: require('@/assets/fms/接单.png'),
          ShutImg: require('@/assets/fms/接单—灰.png')
        })
        if (isPOL) {
          data.push({
            Name: this.$t('DomesticMarineTransportation.Packed'),
            EventDT: this.milestoneTime(item.ShipmentTime),
            OpenImg: require('@/assets/fms/ATA.png'),
            ShutImg: require('@/assets/fms/ATA—灰.png')
          })
        }
        if (isDC) {
          data.push({
            Name: this.$t('DomesticMarineTransportation.Sailed'),
            EventDT: this.milestoneTime(item.ATATime),
            OpenImg: require('@/assets/fms/开航.png'),
            ShutImg: require('@/assets/fms/开航—灰.png')
          })
          data.push({
            Name: this.$t('DomesticMarineTransportation.ArrivedatPort'),
            EventDT: this.milestoneTime(item.ATDTime),
            OpenImg: require('@/assets/fms/到港.png'),
            ShutImg: require('@/assets/fms/到港—灰.png')
          })
        }
        if (isPOD) {
          data.push({
            Name: this.$t('DomesticMarineTransportation.Delivered'),
            EventDT: this.milestoneTime(item.DeliverTime),
            OpenImg: require('@/assets/fms/入库.png'),
            ShutImg: require('@/assets/fms/入库—灰.png')
          })
        }
        return DataTimeMap(data, 'EventDT', null)
      } catch (error) {
        return data
      }
    },
    /** 附件下载 */
    downloadAttachment(row) {
      this.curTitle =
        this.$t('DomesticMarineTransportation.Download') + ' ' + row.Booking_No
      this.curRow = row
      this.oceanfileDialogShow = true
    },
    /** 内装下载 */
    downloadInterior(row) {
      this.interiorTitle =
        'CFS ' +
        this.$t('DomesticMarineTransportation.Download') +
        ' ' +
        row.Booking_No
      this.interiorRow = row
      this.oceanInteriorDialogShow = true
    },
    /** milestone时间大于当前时间的不显示 */
    milestoneTime(time) {
      const contime = convertYMD(time)
      if (ISStr(contime)) return null
      const getDate = convertYMD(new Date())
      if (contime <= getDate) {
        return contime
      } else {
        return null
      }
    },
    /** 导出 */
    exportData() {
      this.loading = true
      this.fullscreenLoading = true
      const pagination = {}
      // 导出全部查询数据
      pagination.pageIndex = 1
      pagination.pagesize = this.listTotalCount
      pagination.sort = 'CreateDT'
      const data = {}
      this.searchSendCarForm.Customer_Code = this.customerCode
      data.pagination = JSON.stringify(pagination)
      data.queryJson = JSON.stringify(this.searchSendCarForm)
      getDomesticTradePageList(data)
        .then((res) => {
          var data = JSON.parse(res.data)
          this.listTotalCount = data?.total
          const result = data?.rows ?? []
          // 转换数据为工作表对象
          var dataList = result.map((x) => {
            var data = {
              Customer_No: x.Customer_No,
              Booking_No: x.Booking_No,
              MBL_NO: x.MBL_NO,
              AUDIT_TYPE: this.orderNode(x),
              // Job_Type: this.$t('DomesticMarineTransportation.MM'),
              CreateDT: convertYMD(x.CreateDT),
              Pkgs_Num: x.Pkgs_Num,
              Pkgs_Unit: x.Pkgs_Unit,
              GW: x.GW,
              CBM: x.CBM,
              POL_Name:
                x[
                  this.$t('DomesticMarineTransportation.POLKey')
                ]?.toUpperCase(),
              POD_Name:
                x[
                  this.$t('DomesticMarineTransportation.PODKey')
                ]?.toUpperCase(),
              CoTypeCount: x.CoTypeCount,
              Container_No: x.Container_No,
              Goods_CN_COUNT:
                x[this.$t('DomesticMarineTransportation.GoodsKey')],

              ReceivingOrdersTime: this.milestoneTime(x.ReceivingOrdersTime)
            }

            // 精准匹配
            const serviceRequests = x.Service_Request?.split(',')
            const isPOL = serviceRequests?.includes('起运港派车')
            const isDC = serviceRequests?.includes('订舱')
            const isPOD = serviceRequests?.includes('目的港派车')
            if (isPOL) {
              data.ShipmentTime = this.milestoneTime(x.ShipmentTime)
            } else {
              data.ShipmentTime = '/'
            }
            if (isDC) {
              data.ATATime = this.milestoneTime(x.ATATime)
              data.ATDTime = this.milestoneTime(x.ATDTime)
            } else {
              data.ATATime = '/'
              data.ATDTime = '/'
            }
            if (isPOD) {
              data.DeliverTime = this.milestoneTime(x.DeliverTime)
            } else {
              data.DeliverTime = '/'
            }
            // 右边时间不能小于左边时间
            var newdata = [
              {
                name: 'ReceivingOrdersTime',
                EventDT: data.ReceivingOrdersTime
              },
              { name: 'ShipmentTime', EventDT: data.ShipmentTime },
              { name: 'ATATime', EventDT: data.ATATime },
              { name: 'ATDTime', EventDT: data.ATDTime },
              { name: 'DeliverTime', EventDT: data.DeliverTime }
            ]
            var updated = DataTimeMap(newdata, 'EventDT', '/')
            data.ShipmentTime = updated[1].EventDT
            data.ATATime = updated[2].EventDT
            data.ATDTime = updated[3].EventDT
            data.DeliverTime = updated[4].EventDT
            return data
          })
          var column = [
            {
              lable: this.$t('DomesticMarineTransportation.CustomerCode'),
              width: 20
            }, // Customer_No
            { lable: this.$t('DomesticMarineTransportation.JobNo'), width: 20 }, // Booking_No
            {
              lable: this.$t(
                'DomesticMarineTransportation.WaterwayShippingNumber'
              ),
              width: 20
            }, // MBL_NO
            {
              lable: this.$t('DomesticMarineTransportation.OrderStatus'),
              width: 15
            }, // AUDIT_TYPE
            // {
            //   lable: this.$t('DomesticMarineTransportation.BusinessType'),
            //   width: 15
            // }, // Job_Type
            {
              lable: this.$t('DomesticMarineTransportation.OrderRange'),
              width: 15
            }, // CreateDT
            {
              lable: this.$t(
                'DomesticMarineTransportation.TotalNumberofPieces'
              ),
              width: 15
            }, // Pkgs_Num
            {
              lable: this.$t(
                'DomesticMarineTransportation.TotalNumberofPiecesUnit'
              ),
              width: 15
            }, // Pkgs_Unit
            {
              lable: this.$t('DomesticMarineTransportation.GrossWeightKGS'),
              width: 15
            }, // GW
            {
              lable: this.$t('DomesticMarineTransportation.VolumeCBM'),
              width: 15
            }, // CBM
            {
              lable: this.$t('DomesticMarineTransportation.LoadingPort'),
              width: 20
            }, // POL_Name
            {
              lable: this.$t('DomesticMarineTransportation.DestinationPort'),
              width: 20
            }, // POD_Name
            {
              lable: this.$t('DomesticMarineTransportation.Containers'),
              width: 30
            }, // CoTypeCount
            {
              lable: this.$t('DomesticMarineTransportation.ContainerNumber'),
              width: 30
            }, // Container_No
            {
              lable: this.$t('DomesticMarineTransportation.Goods'),
              width: 100
            }, // Goods_CN_COUNT

            {
              lable: this.$t('DomesticMarineTransportation.OrderReceived'),
              width: 20
            }, // ReceivingOrdersTime
            {
              lable: this.$t('DomesticMarineTransportation.Packed'),
              width: 20
            }, // ShipmentTime
            {
              lable: this.$t('DomesticMarineTransportation.Sailed'),
              width: 20
            }, // ATATime
            {
              lable: this.$t('DomesticMarineTransportation.ArrivedatPort'),
              width: 20
            }, // ATDTime
            {
              lable: this.$t('DomesticMarineTransportation.Delivered'),
              width: 20
            } // DeliverTime
          ]
          exportToExcel({
            column,
            dataList,
            filename:
              this.$t('DomesticMarineTransportation.MMOrderDetial') +
              parseTime(new Date(), '_{y}{m}{d}')
          })
          this.loading = false
          this.fullscreenLoading = false
        })
        .catch((err) => {
          this.loading = false
          this.fullscreenLoading = false
          console.log(err)
        })
    },
    /** 根据订单节点显示订单状态 */
    orderNode(row) {
      // milestone时间大于当前时间的不显示，订单状态也需要不显示
      const getDate = convertYMD(new Date())
      // 精准匹配
      const serviceRequests = row.Service_Request?.split(',')
      const isPOL = serviceRequests?.includes('起运港派车')
      const isDC = serviceRequests?.includes('订舱')
      const isPOD = serviceRequests?.includes('目的港派车')
      if (
        !ISStr(row.DeliverTime) &&
        convertYMD(row.DeliverTime) <= getDate &&
        isPOD
      ) {
        return this.$t('DomesticMarineTransportation.Delivered2')
      } else if (
        !ISStr(row.ATDTime) &&
        convertYMD(row.ATDTime) <= getDate &&
        isDC
      ) {
        return this.$t('DomesticMarineTransportation.ArrivedatPort2')
      } else if (
        !ISStr(row.ATATime) &&
        convertYMD(row.ATATime) <= getDate &&
        isDC
      ) {
        return this.$t('DomesticMarineTransportation.Sailed2')
      } else if (
        !ISStr(row.ShipmentTime) &&
        convertYMD(row.ShipmentTime) <= getDate &&
        isPOL
      ) {
        return this.$t('DomesticMarineTransportation.Packed2')
      } else if (
        !ISStr(row.ReceivingOrdersTime) &&
        convertYMD(row.ReceivingOrdersTime) <= getDate
      ) {
        return this.$t('DomesticMarineTransportation.OrderReceived')
      } else {
        return ''
      }
    },
    /**  点击时切换展开和收缩状态 */
    toggleCollapse(row) {
      row.collapsed = !row.collapsed
    },
    formatUpper(row, column) {
      if (row[column.property]) {
        return row[column.property].toUpperCase()
      } else return ''
    },
    getUpper(i) {
      if (i) return i.toUpperCase()
      else return ''
    },
    remoteQuery(query, call) {
      console.log(query)
      if (call) {
        call([{ a: '1', b: '2' }])
      }
    },
    async remoteQueryPOL(query, call) {
      const res = await GetSeaProts({ KeyWord: query, portType: '国内港口' })
      if (call) {
        if (res.isSuccess) {
          call(res.data)
        } else {
          call([])
        }
      }
    },
    async remoteQueryPOD(query, call) {
      const res = await GetSeaProts({ KeyWord: query, portType: '国内港口' })
      if (call) {
        if (res.isSuccess) {
          call(res.data)
        } else {
          call([])
        }
      }
    },
    remoteSelect(row, call) {
      if (call) {
        call(row.seaportName)
      }
    }
  }
}
</script>
<style scoped>
@import '~@/styles/fms/tableClass.scss';
.orderSearch >>> .el-date-editor .el-range-separator {
  display: block;
  width: initial;
}
.orderSearch >>> .el-form-item {
  margin-bottom: initial;
}
.orderSearch >>> .el-table .el-table__cell {
  padding: initial;
}

/* 公共样式提取至内部 开始*/
.custom-input >>> .el-input__inner {
  /* border: 1px solid #dcdfe6; */
  background: #fff;
  max-width: 500px;
}

.custom-input.el-input__inner >>> {
  /* border: 1px solid #dcdfe6; */
  background: #fff;
  max-width: 280px;
}
.custom-input.el-date-editor {
  background: #fff !important;
}
.custom-input.el-date-editor >>> .el-input__icon {
  display: none;
}
.custom-input >>> input {
  background: #fff !important;
  flex: 1;
  width: 100%;
}
.custom-el-collapse {
  border: 0;
}
.custom-el-collapse .el-collapse-item {
  border-radius: 8px;
  margin-bottom: 13px;
  box-shadow: none;
}
.custom-el-collapse .el-collapse-item >>> .el-collapse-item__header {
  margin: 0;
  font-size: 16px;
  font-weight: normal !important;
  height: auto;
  color: #111827;
  background-color: #fff !important;
  border: 0 !important;
  border-radius: 8px !important;
  line-height: initial;
}
.custom-el-collapse .el-collapse-item >>> .el-collapse-item__wrap {
  border-top: 1px solid #dcdee2;
  border-radius: 0 0 8px 8px;
}
.custom-el-collapse .el-collapse-item >>> .el-collapse-item__content {
  padding-bottom: 0px !important;
}
/* 公共样式提取至内部 结束 */

.mtf1 {
  margin-top: -1px;
  border-top: #fff;
}
.mtf1 >>> .el-card__body {
  padding: 20px 20px 20px 39px !important;
}
.mt10 {
  margin-top: 16px;
}
.mb20 {
  margin-bottom: 0px;
  padding: 10px 20px 10px 20px;
  border-radius: 4px 4px 0 0;
  border: 1px solid #ebeef5;
}
.ml18 {
  margin-left: 17px;
}
.mb48 {
  margin-bottom: 48px;
}
.w100 {
  width: 100%;
}
.floatR {
  float: right;
}
.el-collapse .divTitle {
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
}
.inline-block {
  display: inline-block;
}
.showType {
  width: 20px;
  height: 20px;
}
.footPage {
  z-index: 3;
  background-color: #fff;
  height: 48px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 36px;
  padding: 8px 16px;
}
/* 样式改版 */
.text-content {
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 使用省略号代替溢出部分 */
  white-space: nowrap; /* 不换行 */
}
.search {
  border: 1px solid #67b0c4 !important;
  border-color: #67b0c4 !important;
  color: #67b0c4;
}
.order-img {
  width: 24px !important;
  height: 30px !important;
  display: inline-block;
}
.mt10 >>> .el-card__body {
  padding: 0px !important;
}
.order-title {
  padding: 36px 45.5px 33px 32px;
  width: 100% !important;
}
.custom-el-collapse {
  background-color: aliceblue;
}
.order-label {
  font-size: 16px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 500;
  text-align: left;
  color: #333333;
  line-height: 24px;
}
.order-text {
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #666666;
  line-height: 22px;
}
.order-text-booking {
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #67b0c4;
  border-radius: 6px;
  line-height: 22px;
}
.order-text-jobtype {
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  line-height: 22px;
  background: #fdede6;
  color: #eb5c20;
  border-radius: 6px;
  padding: 2px 10px 2px 10px;
}
.details-label {
  width: 110px;
  font-weight: bold;
}
.details-value {
  width: calc(100% - 123px);
}
.details-text {
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  /* font-weight: 400; */
  text-align: left;
  color: #666666;
  line-height: 22px;
}
.details-title {
  font-size: 16px;
  font-family: Source Han Sans SC, Source Han Sans SC-Bold;
  font-weight: 700;
  text-align: left;
  color: #333333;
  line-height: 24px;
  margin-bottom: 13px;
}
.custom-el-button span {
  display: flex !important;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
.custom-el-button img {
  width: 14px;
  height: 14px;
  margin-right: 5px;
}
.custom-el-collapse >>> .el-collapse-item__arrow {
  display: none !important;
}
.collapsed {
  float: right;
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #67b0c4;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.order-title-wrap {
  padding: 25px 28px 17px 27px !important;
}
.orderSearch >>> .el-card {
  border: 0px !important;
}
.buttonSize {
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
}
.custom-el-form {
  padding: 0 16px;
}
.custom-el-form > .el-form-item {
  width: 25%;
  margin: 0;
  padding-top: 10px;
  padding-right: 10px;
  display: inline-flex;
}
.custom-el-form > .el-form-item >>> .el-form-item__content {
  flex: 1;
}
.custom-el-form >>> .el-input__inner {
  max-width: initial;
}
</style>
